module.exports = __webpack_public_path__ + "static/media/defaultMale.5c99ec1e.jpg";